import React, { ReactElement } from 'react'
import Icon from '@ant-design/icons'

const FavouriteIconSvg = (): ReactElement => (
  <svg width='34' height='34' viewBox='0 0 60 60' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='30' cy='30' r='30' fill='#00366B' />
    <path
      d='M29.5073 41.8969L22.1874 46.3291V25.0646H37.8135V46.3541L30.0147 41.8907L29.7591 41.7444L29.5073 41.8969Z'
      fill='white'
      stroke='white'
    />
    <path d='M29.7663 24.5646H21.6874V47.2164L29.7663 42.3246V24.5646Z' fill='#AED8EB' />
    <circle cx='30.0003' cy='24.5373' r='11.7501' fill='#AED8EB' />
  </svg>
)

export const FavouriteIcon = (props): ReactElement => <Icon component={FavouriteIconSvg} {...props} />
